const redirectDomain = process.env.VUE_APP_REDIRECT_DOMAIN
const redirectUrl = process.env.VUE_APP_REDIRECT_URL

export const url = `${redirectDomain}/authorize?response_type=code&client_id=operation_center&redirect_uri${redirectUrl}&state=${Date.now()}`
